<script setup lang="ts">
import { PropType, ref } from 'vue';
import {
  ContainerTypes,
  Contexts,
  NamedBindings,
  TranslationService,
  getContainer,
} from '@dandelion/core';

const props = defineProps({
  fullName: {
    type: String as PropType<string>,
    required: false,
    default: '',
  },
  context: {
    type: String as PropType<string>,
    required: false,
    default: Contexts.DEFAULT,
  },
  containerType: {
    type: String as PropType<ContainerTypes>,
    required: false,
    default: () => ContainerTypes.DEFAULT,
  },
});

let buttonName = ref('Collapse');
let isExpanded = ref(true);

const ts = getContainer(Contexts.DEFAULT).get(
  NamedBindings.TranslationService
) as TranslationService;

function checkIfCollapse() {
  if (props.fullName != 'core.proceduresTreatments.procedures') {
    return false;
  }
  return true;
}

function collapse() {
  const procedures = document.getElementById(
    'core.proceduresTreatments.procedures'
  )!;
  if (isExpanded.value == true) {
    procedures.style.display = 'none';
    buttonName.value = 'Expand';
    isExpanded.value = false;
  } else {
    procedures.style.display = 'grid';
    buttonName.value = 'Collapse';
    isExpanded.value = true;
  }
}
</script>

<template>
  <button
    v-if="checkIfCollapse()"
    id="collapseButton"
    type="button"
    @click="collapse()"
    v-html="ts.t(buttonName)"
  ></button>
</template>

<style scoped></style>
